import cn from "classnames";
import { useAppSelector } from "hooks/useAppSelector";
import { useTranslation } from "localization/localization";
import {
  getInvalidRequiredCargoFields,
  RequiredCargoField,
  selectGroupById,
  selectOptions,
  selectShowCargoValidation,
} from "store";
import { CargoTableProps } from "./CargoTable.types";
import { CargoRow } from "./CargoRow";
import s from "./CargoTable.module.scss";

export const CargoTable = ({ groupId }: CargoTableProps) => {
  const { t } = useTranslation();
  const group = useAppSelector(selectGroupById(groupId));
  const { lengthUnits, weightUnits } = useAppSelector(selectOptions);
  const showValidation = useAppSelector(selectShowCargoValidation);

  const invalidColumns = new Set<RequiredCargoField>();
  if (showValidation && group) {
    for (const row of group.cargoRows) {
      for (const field of getInvalidRequiredCargoFields(row)) {
        invalidColumns.add(field);
      }
    }
  }

  const headerError = (field: RequiredCargoField) => invalidColumns.has(field);

  return (
    <div className={s.table}>
      <div className={s.header}>
        <div className={s.headerCell}>{t("Cargo name")}</div>
        <div className={s.headerCell}>{t("Package type")}</div>
        <div className={cn(s.headerCell, headerError("length") && s.headerCellError)}>
          {t(`Length, ${lengthUnits}`)}
        </div>
        <div className={cn(s.headerCell, headerError("width") && s.headerCellError)}>{t(`Width, ${lengthUnits}`)}</div>
        <div className={cn(s.headerCell, headerError("height") && s.headerCellError)}>
          {t(`Height, ${lengthUnits}`)}
        </div>
        <div className={cn(s.headerCell, headerError("weight") && s.headerCellError)}>
          {t(`Weight, ${weightUnits}`)}
        </div>
        <div className={cn(s.headerCell, headerError("qty") && s.headerCellError)}>{t("Q-ty")}</div>
        <div className={s.headerCell}>{t("Color")}</div>
      </div>

      {group?.cargoRows.map((row) => <CargoRow key={row.id} rowId={row.id} groupId={groupId} />)}
    </div>
  );
};
